// This file is auto-generated by @oracle/oraclejet-icu-l10n from src/resources/icu/bundle.json
// and should not be edited by hand. Update the JSON file and rerun the build to regenerate this content.

const bundle = {
  close: () => 'Zatvori',
  error: () => 'Pogreška',
  warn: () => 'Upozorenje',
  info: () => 'Informacije',
  confirmation: () => 'Potvrda',
  progressIndeterminate: () => 'U tijeku',
  indexer_separatorLabel: (p: { FROM_SECTION: string; TO_SECTION: string }) =>
    'Između ' + p['FROM_SECTION'] + ' i ' + p['TO_SECTION'] + '.',
  indexer_disabledLabel: (p: { SECTION: string }) =>
    p['SECTION'] + '. Nije pronađena odgovarajuća sekcija.',
  indexer_othersLabel: () => '#',
  indexer_keyboardInstructionText: () => 'Pritisnite Enter za odabir vrijednosti.',
  indexer_touchInstructionText: () =>
    'Dvaput pritisnite i zadržite kako biste otvorili način za poteze, a zatim povucite gore ili dolje za prilagodbu vrijednosti.',
  inputPassword_show: () => 'Prikaži lozinku',
  inputPassword_hide: () => 'Sakrij lozinku',
  inputPassword_hidden: () => 'Lozinka skrivena',
  formControl_clear: () => 'Očisti',
  formControl_loading: () => 'Učitavanje',
  formControl_maxLengthExceeded: (p: { MAX_LENGTH: string }) =>
    'Prekoračena je maksimalna duljina ' + p['MAX_LENGTH'] + '.',
  formControl_maxLengthRemaining: (p: { CHARACTER_COUNT: string }) =>
    'Preostali broj znakova: ' + p['CHARACTER_COUNT'] + '.',
  formControl_requiredMessageDetail: () => 'Unesite vrijednost.',
  select_requiredMessageDetail: () => 'Odabir vrijednosti.',
  select_noMatchesFound: () => 'Nije pronađen nijedan rezultat.',
  select_oneMatchFound: () => 'Pronađen jedan rezultat',
  select_sizeMatchesFound: (p: { TOTAL_SIZE: string }) =>
    'Pronađen sljedeći broj odgovarajućih rezultata: ' + p['TOTAL_SIZE'],
  select_sizeOrMoreMatchesFound: (p: { TOTAL_SIZE: string }) =>
    'Pronađen sljedeći broj ili više odgovarajućih rezultata: ' + p['TOTAL_SIZE'],
  selectMultiple_selectedValues: () => 'Odabrane vrijednosti',
  selectMultiple_showSelectedValues: () => 'Prikazuju se samo odabrane vrijednosti.',
  selectMultiple_valuesSelected: (p: { VALUE_COUNT: string }) =>
    'Odabran sljedeći broj vrijednosti: ' + p['VALUE_COUNT'] + '.',
  selectMultiple_countPlus: (p: { COUNT: string }) => p['COUNT'] + '+',
  selectMultiple_removeSelectedTagInstructionText: () =>
    'Pritisnite Backspace ili Delete kako biste uklonili odabranu vrijednost.',
  selectMultiple_apply: () => 'Primijeni',
  selectMultiple_back: () => 'Natrag',
  selector_selected: () => 'Potvrdni okvir uključen',
  selector_unselected: () => 'Potvrdni okvir nije uključen',
  userAssistance_learnMore: () => 'Saznajte više',
  userAssistance_required: () => 'Obavezno',
  filePicker_singleFileUploadError: () => 'Datoteke učitavajte jednu po jednu',
  filePicker_singleTypeUploadError: (p: { fileType: string }) =>
    'Ne možete učitati datoteke koje pripadaju vrsti ' + p['fileType'],
  filePicker_multipleFileTypeUploadError: (p: { fileTypes: string }) =>
    'Ne možete učitati datoteke koje pripadaju vrsti: ' + p['fileTypes'],
  filePicker_unknownFileTypeUploadError: () => 'nepoznato',
  filePicker_dropzonePrimaryText: () => 'Povuci i ispusti',
  filePicker_dropzoneSecondaryText: () => 'Odaberite datoteku ili je ovdje ispustite',
  filePicker_dropzoneSecondaryTextMultiple: () => 'Odaberite datoteke ili ih ovdje ispustite',
  filePicker_addFiles: () => 'Dodaj datoteke',
  plural_separator: () => ', ',
  inputNumber_increase: () => 'Povećaj',
  inputNumber_decrease: () => 'Smanji',
  inputNumber_converterParseError: () => 'Unesite broj.',
  noData_message: () => 'Nema stavki za prikaz',
  message_navigationFromMessagesRegion: () =>
    'Ulazite u područje za poruke. Pritisnite F6 za povratak na ranije fokusirani element.',
  message_navigationToMessagesRegion: () =>
    'U regiji za poruke postoje nove poruke. Pritisnite F6 kako biste se vratili na regiju najnovije poruke.',
  messageToast_allMessagesClosed: () => 'Zatvorene su sve poruke sa skočnim prozorčićem.',
  expandableList_groupCollapse: () => 'Sakriveno',
  expandableList_groupExpand: () => 'Prošireno',
  expandableList_expandCollapseInstructionText: () =>
    'Za proširivanje i sažimanje upotrijebite tipke sa strelicama',
  list_suggestion: () => 'Prijedlog',
  train_status: (p: { currentStep: string; numberOfSteps: string }) =>
    'Korak ' + p['currentStep'] + ' od ' + p['numberOfSteps'],
  train_current: () => 'Trenutačno',
  train_visited: () => 'Posjećeno',
  train_not_visited: () => 'Nije posjećeno',
  train_message_type: () => 'Vrsta poruke',
  viz_drillable: () => 'Može se analizirati',
  dataVisualization_stateSelected: () => 'Odabrano',
  dataVisualization_stateUnselected: () => 'Poništen odabir',
  dataVisualization_noData: () => 'Nema podataka za prikaz'
};
export default bundle;
